import { render, staticRenderFns } from "./CnNewSpec.vue?vue&type=template&id=03b236e8&"
import script from "./CnNewSpec.vue?vue&type=script&lang=js&"
export * from "./CnNewSpec.vue?vue&type=script&lang=js&"
import style0 from "./CnNewSpec.vue?vue&type=style&index=0&id=03b236e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports